import styled, { css } from 'styled-components'

import { values } from '@chegg-wt/core/theme/sunkist/spacing'
import {
  Icon as PMIcon,
  Label as PMLabel,
  ListItem,
  ItemAction,
} from '@chegg-wt/core/components/Folders/shared/ProjectMenu/styled'
import { Gear as OriginalGear } from '@chegg-wt/core/components/Icon'
import OriginalFolderSettingsMenu from '@chegg-wt/core/components/Folders/shared/FolderSettingsMenu'
import {
  SunkistIconColors,
  SunkistIconHoverColors,
} from '@chegg-wt/core/components/Icon/styled'
import { IconButton } from '@chegg-ui/button'
import { adjust, themeBreakPoints } from '@chegg-wt/core/theme/theme'

export const Label = styled(PMLabel)``

export const GearIcon = styled(OriginalGear)`
  ${SunkistIconColors};
`
export const Icon = styled(PMIcon)``

export const FoldersListAction = styled(ItemAction)``

/**
 * [1]: We don't want to show this component when we're in mobile-ish design
 */
export const SettingsMenuAction = styled(IconButton)`
  padding: 0;
  justify-content: flex-start;

  @media (max-width: ${({ theme }) => adjust(themeBreakPoints.small(theme), -1)}) {
    display: none; /* [1] */
  }
  @media (min-width: ${({ theme }) => themeBreakPoints.small(theme)}) {
    display: inline-flex;
    flex-direction: column;
  }

  &:hover,
  &:focus-within {
    ${GearIcon} {
      ${SunkistIconHoverColors}
    }
  }
`

export const FolderSettingsMenu = styled(OriginalFolderSettingsMenu)``

const FoldersListItemLayout = css`
  & > * {
    flex: 0 0 auto;
  }

  & > ${FoldersListAction} {
    flex: 1 1 auto;
    min-width: 0;
    :focus {
      outline: none;
    }
  }

  & > * + * {
    margin-left: ${values.xsmall};
  }
`

const ListItemPositionedLayout = css`
  position: relative;

  & ${FolderSettingsMenu} {
    position: absolute;
    width: 100%;
    max-width: 180px;
    right: 0;
    top: 100%;
    z-index: 1;
  }
`

export const FoldersListItem = styled(ListItem)`
  ${FoldersListItemLayout};
  ${ListItemPositionedLayout};

  &:not(:hover):not(:focus-within) > ${SettingsMenuAction} {
    display: none;
  }
`
